import styled from "styled-components";
import { theme } from "styles";

export const SimpleLink = styled("a")`
  font-weight: 500;
  color: ${theme.colors.TealGreen};
  text-decoration: none;
`;
